import React, { useEffect, useState } from "react";
import api from '../../services/api';
import Modal from 'react-modal';
import Swal from "sweetalert2";
import Flex from '@react-css/flex';
import { DynamicTextareaOnChange } from "../../components/DynamicTextarea";
import { DynamicSelect } from "../../components/DynamicSelect";
import { StyledForm } from "../../styled-components/StyledForm.style";

export const ModalVisibilidadeTransferir = ({
    processo,
    laudo,
    peritos,
    isOpen,
    setIsOpen,
    aoSalvar
}) => {
    const [isLoading, setisLoading] = useState(false);
    const [loadAcao, setLoadAcao] = useState(null);
    const [observacao, setObservacao] = useState("");

    var [perito, setPerito] = useState(null);
    var [idPerito, setIdperito] = useState(null);
    const [peritoList, setPeritoList] = useState([]);

    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '35%',
            overflowY: 'auto',
            minHeight: '25%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        }
    }

    const onAfterOpen = () => { };
    const closeModal = () => { 
        setIdperito(null);
        setPerito(null);
        setObservacao("");
        setisLoading(false);
        setIsOpen(false);
     }

    const getPeritos = (currentValue, value) => {
        if (!value) {
            setPerito(null);
            setIdperito(null);
            return;
        }
        
        var peritoResult = peritoList.filter(function (o) {
            return o.idUsuario == value;
        });

        perito = peritoResult[0].nome;
        idPerito = peritoResult[0].idUsuario;
        setPerito(perito);
        setIdperito(idPerito);
    };

    const getLoadAcao = async (idTarefa) => {
        setisLoading(true);
        let list = null;
        try {
            const response = await api.get(`Visibilidade/tarefa/load/acao/${idTarefa}`);
            list = response.data.data;
            setLoadAcao(list);
        } catch (err) {
            console.error(err);
        } finally {
            setisLoading(false);
            return list;
        }
    }

    const onTransferirTarefa = (idTarefa, idProcesso) => {
        Swal.fire({
            html: `Deseja Transferir a Tarefa para <strong>${perito}</strong>?`,
            icon: "info",
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            setisLoading(true);
            if (result.isConfirmed) {
                Swal.showLoading();
                try {
                    const headers = {
                        'Content-Type': 'application/json'
                    };

                    const dados = {
                        idUsuario: idPerito ? parseInt(idPerito) : null,
                        observacao: observacao,
                    };
                    await api.post(`Visibilidade/tarefa/executa/transferir/${idTarefa}`, dados, { headers });
                    setisLoading(false);

                    Swal.fire({
                        title: "Sucesso",
                        text: "Tarefa Transferida com Sucesso!",
                        icon: "success",
                        timer: 2000,
                        timerProgressBar: true,
                        showConfirmButton: false
                    }).then(() => {

                        setIdperito(null);
                        setPerito(null);
                        setObservacao("");

                        setisLoading(false);
                        setIsOpen(false);
                        closeModal();

                        if (aoSalvar) { aoSalvar(laudo.idProcesso, laudo.idTipoServico); }
                    });

                } catch (err) {setisLoading(false);}
            } else {
                setisLoading(false);
            }
        });
    };

    useEffect(() => {
        if(isOpen) {
            setPeritoList(peritos);
            getLoadAcao(processo.idTarefa);
        }
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={closeModal}
            contentLabel="Modal Transferir Tarefa"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="pull-left">
                                <p className="modal-title">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="28" height="28" className="me-2">
                                        <path fill={'#999'} d="M502.6 150.6l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 160 32 160c-17.7 0-32-14.3-32-32S14.3 96 32 96l370.7 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3zm-397.3 352l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 352 480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32l-370.7 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"/></svg>
                                    Transferir - { loadAcao?.nomeEtapa } </p>
                            </div>
                            <div className="pull-right">
                                <p className="modal-close" onClick={closeModal}><button className="default-button-red-small px-2">X</button></p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                { isLoading ? 
                    (
                    <div className="text-center">
                        <div className="text-items-center">
                            <div className="spinner-border ms-auto mt-2" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                            <div className="mt-2">
                                <strong style={{ color: "#EE4B21" }}>Aguarde enquanto validamos as informações</strong>
                            </div>
                        </div>
                    </div>
                    ) : (
                    <>
                    <div className="row mb-2" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Processo</span><br/>{ loadAcao?.processo?.processoSigla || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Líder</span><br/>{ loadAcao?.processo?.liderProcesso || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Cliente</span><br/>{ loadAcao?.processo?.cliente || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Segurado</span><br/>{ loadAcao?.processo?.segurado || "-" }</div>
                    </div>
                    <div className="row" style={{ fontSize: "14px" }}>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Disciplina</span><br/>{ laudo.disciplina }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Responsável</span><br/>{ loadAcao?.nomeUsuarioResponsavel || "-" }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Criação</span><br/>{ new Date(loadAcao?.dataCriacao).toLocaleDateString('pt-BR') }</div>
                        <div className="col-3 text-center"><span style={{ color: "#999" }}>Data Prazo</span><br/>{ new Date(loadAcao?.dataPrazo).toLocaleDateString('pt-BR') }</div>

                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <div className="row align-items-center justify-content-center mt-3">
                        <div className="col-12 text-center mb-2">
                            <DynamicSelect placeholder={''} valuetext={perito} label={'Profissionais'} name={'idPerito'} options={[...peritoList].sort((a, b) => a.nome.localeCompare(b.nome))} keyValue={'idUsuario'} keyLabel={'nome'} clearOption={true} paramMethod={getPeritos} />
                        </div>
                    </div>

                    <div className="row align-items-center justify-content-center">
                        <div className="col-12 text-center">
                            <DynamicTextareaOnChange 
                                placeholder={"Observações"} 
                                label={"Observações"} 
                                name={"observacao"}
                                valuetext={observacao}
                                onChange={(e) => setObservacao(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="modal-divider" style={ { opacity: "0.3" }}><hr /></div>

                    <Flex>
                        <Flex.Item>
                            <div className="row align-items-center justify-content-center">
                                <div className="col text-center">
                                    <input 
                                        className='default-button-red' 
                                        value={'Transferir'} 
                                        type="button"
                                        onClick={onTransferirTarefa.bind(this, processo.idTarefa, processo.idProcesso)}
                                    />
                                </div>
                            </div>
                        </Flex.Item>
                    </Flex>
                    </>
                )}
            </StyledForm>
        </Modal>
    );
};